module.exports = __webpack_public_path__ + "static/regtech-lg-4eece8c5749fd3635ea597232eaf86be.jpg";